module.exports = __webpack_public_path__ + "img/frame (60).b6e317fe.jpg";